import { createSlice } from "@reduxjs/toolkit";

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    message: "",
    type: "info", // "success", "error", "warning", "info"
    open: false,
  },
  reducers: {
    showNotification: (state, action) => {
      const { message, type } = action.payload;
      state.message = message;
      state.type = type;
      state.open = true;
    },
    hideNotification: (state) => {
      state.open = false;
      state.message = "";
    },
  },
});

export const { showNotification, hideNotification } =
  notificationsSlice.actions;
export const selectNotification = (state) => state.notifications;
export default notificationsSlice.reducer;
